module.exports = "data:text/x-markdown;base64,QSB2ZW50dXJlIGNhcGl0YWwgdXNlcyBzbWFydCBjb250cmFjdCB0byBtYW5hZ2UgdGhlaXIgY2xpZW50cyBhbmQgZnVuZHMsIGFuZCBhcyBhIGhhY2tlciAod2hpY2ggaXMgeW91KSwgeW91ciBtaXNzaW9uIGlzIHRvIHdpdGhkcmF3IHRoZSBhbGwgZnVuZHMgYXQgdGhlIGFkZHJlc3Mgb2YgdGhpcyBzbWFydCBjb250cmFjdCEgIApHb29kIGx1Y2sgYW5kIGhhdmUgaHVuIQo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/ventureCapital.md
// module id = 1415
// module chunks = 0